// src/components/AddPermanentInvitationListModal.jsx
import React, { useState } from "react";
import PropTypes from "prop-types";

function AddPermanentInvitationListModal({ isOpen, onClose, onSave }) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  if (!isOpen) return null;

  const handleSave = async () => {
    if (!name.trim()) {
      alert("Please enter a list name.");
      return;
    }
    await onSave({ name, description });
  };

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg shadow-lg w-[400px] relative">
        {/* Кнопка закрытия (svg) */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 transition duration-200"
          aria-label="Close"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <h3 className="text-xl font-bold mb-4 text-gray-800">Add New Invitation List</h3>

        {/* Поле "List Name" */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">List Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter list name"
            className="mt-1 block w-full border border-gray-300 p-2 rounded-md shadow-sm 
                       focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
          />
        </div>

        {/* Поле "Description" */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Description (optional)</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={3}
            placeholder="Enter description"
            className="mt-1 block w-full border border-gray-300 p-2 rounded-md shadow-sm
                       focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
          />
        </div>

        {/* Кнопки действия */}
        <div className="flex justify-center space-x-4 mt-6">
          <button
            onClick={handleSave}
            className="bg-indigo-600 text-white px-6 py-2 rounded-md hover:bg-indigo-700 
                       transition duration-200 font-medium disabled:opacity-50 
                       disabled:cursor-not-allowed"
            disabled={!name.trim()}
          >
            Save
          </button>
          <button
            onClick={onClose}
            className="bg-white text-gray-700 px-6 py-2 rounded-md hover:bg-gray-100 
                       transition duration-200 border border-gray-300 font-medium"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

AddPermanentInvitationListModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default AddPermanentInvitationListModal;
